import React, { useEffect, useState } from "react";

import { useHistory, useParams } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert } from "react-bootstrap";
import toast from "react-hot-toast";
import TopBox from "../../components/TopBox";
import useRedirect from "../../hooks/Redirect";
import { axiosInstance } from "../../api/axiosDefaults";
import styles from "../../styles/Scene.module.css";
import btnStyles from "../../styles/Button.module.css";

export default function EpisodeEditForm() {
  useRedirect();
  const history = useHistory();
  const params = useParams();
  console.log(params);
  // eslint-disable-next-line
  const [errors, setErrors] = useState({});

  const [postData, setPostData] = useState({
    number: "",
    title: "",
  });

  const { number, title } = postData;

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // const formData = new FormData();

    // formData.append("number", number);
    const body = {
      episode_number: number,
      title: title,
    };

    try {
      const response = await axiosInstance.put(
        `${localStorage.getItem("projectSlug")}/scene_episodes/${
          params?.episodeId
        }/`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          withCredentials: true,
        }
      );
      if (response?.success === false) {
        throw response.error;
      }
      toast.success("Episode Updated Successfully");
      history.goBack();
    } catch (err) {
      console.log(err);
      const backendError =
        err?.response?.data?.error ||
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        "Failed to edit Episode. Try again";
      toast.error(backendError);
      if (err.response?.status !== 401) {
        setErrors(err.response?.data || { detail: [backendError] });
      }
    }
  };

  const buttons = (
    <div className={`text-center pt-3 mb-3 pb-2 ${styles.White}`}>
      <Button
        className={`mr-3 px-5 ${btnStyles.Button} ${btnStyles.Blue}`}
        onClick={() => history.goBack()}
      >
        Cancel
      </Button>
      <Button
        className={`ml-3 px-5  ${btnStyles.Button} ${btnStyles.Blue}`}
        type="submit"
      >
        Update
      </Button>
    </div>
  );

  const fetchEpisode = async (episodeId) => {
    try {
      const { data } = await axiosInstance.get(
        `${localStorage.getItem("projectSlug")}/scene_episodes/${episodeId}/`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          withCredentials: true,
        }
      );

      console.log(data);
      setPostData((prev) => ({
        ...prev,
        title: data?.title,
        number: data?.episode_number,
      }));
      // setSeries(data.results);
    } catch (error) {
      console.log("fetch series error: ", error);
    }
  };

  useEffect(() => {
    if (params?.episodeId) {
      fetchEpisode(params?.episodeId);
    } else {
      return;
    }
  }, [params]);

  return (
    <div>
      <TopBox title="Edit Episodes" />
      <Row>
        {/* back bit */}
        <Col xs={12}>
          <Button
            className={`${btnStyles.Button} ${btnStyles.Blue} py-0 mt-2`}
            onClick={() => history.goBack()}
          >
            Back
          </Button>
        </Col>
      </Row>
      <h3 className="text-center">Edit Episode</h3>
      <Form className={`mb-3 ${styles.Back}`} onSubmit={handleSubmit}>
        <Row className="text-center">
          <Col
            className="text-center p-2"
            xs={12}
          >
            <p className={`${styles.BoldScene}`}>Episode Number</p>
            <p className={`${styles.Bold}`}>{number}</p>
            {/* <Form.Group controlId="number" className={`${styles.Width2} `}>
              <Form.Label className={`${styles.BoldScene}`}>
                Episode Number
              </Form.Label>
              <Form.Control
                className={styles.Input}
                type="text"
                name="number"
                value={number}
                onChange={handleChange}
              />
            </Form.Group>
            {errors?.number?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))} */}
          </Col>
        </Row>
        <Row className="text-center">
          <Col
            className="d-flex justify-content-center p-2"
            xs={12}
          >
            <Form.Group controlId="title" className={`${styles.Width2} `}>
              <Form.Label className={`${styles.BoldScene}`}>Title</Form.Label>
              <Form.Control
                className={styles.Input}
                type="text"
                name="title"
                value={title}
                onChange={handleChange}
              />
            </Form.Group>
            {errors?.title?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
          </Col>
        </Row>
        <Row>
          <Col className="text-center">
            <div className={`mt-3 ${styles.Container}`}>{buttons}</div>
          </Col>
        </Row>
      </Form>
    </div>
  );
}
